var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/@stimulus/polyfills/~/core-js/modules/_core.js
// module id = 35
// module chunks = 0